import type { Program } from 'models';
import { Col, RichTextRenderer } from 'ui';
import { Translation } from 'features/translations';
import { Text } from 'ui/typography';

type P = {
  program: Program;
};

/**
 * @deprecated This component was only ported to TypeScript as-is as part of #86881, not redesigned. Do not use it as a
 * reference for new code.
 */
const ProgramDescriptionContent = ({ program }: P) => {
  if (program.htmlContent) {
    return (
      <Col span={24}>
        <RichTextRenderer data={program.htmlContent} />
        <Translation id={program.id} type="program" />
      </Col>
    );
  }

  if (program.textContent) {
    return (
      <Col span={24}>
        <Text className="program-description-content__text">{program.textContent}</Text>
      </Col>
    );
  }

  return (
    <Col span={24}>
      <Text className="program-description-content__text">No Description</Text>
    </Col>
  );
};

export default ProgramDescriptionContent;
